import Modal from 'components/common/Modal/Modal';

import styles from './CancelModal.scss';

const CancelModal = ({ isOpen, onCancel, onClose, onSave, title, helperText, onCancelText, onSaveText }) => {
    if(!isOpen) {
        return null;
    }
    return ( 
        <Modal title={title} open={isOpen} onClose={onClose} data-cy="CancelModal">
            <p className={styles.cancelModal__description} data-cy="CancelModal-helperText">{helperText}</p>
            <div className={styles.cancelModal__buttons}> 
                <button className={styles.cancelModal__cancelButton} onClick={() => onCancel()} data-cy="CancelModal-onCancel">
                    {onCancelText}
                </button>
                <button className={styles.cancelModal__saveButton} onClick={() => onSave()} data-cy="CancelModal-onSave">
                    {onSaveText}
                </button>
            </div>
        </Modal>
    );
};

export default CancelModal;